import { IApiError, TApiErrorCallback } from "../api.interfaces";
import { IPerTypeStrategy } from "./interfaces";

export class FallBackStrategy implements IPerTypeStrategy {
    handle(error: IApiError, errorCallback: TApiErrorCallback | undefined): void {
        errorCallback?.(error);
    }
}
